<div data-test="QNIeKy23" class="calendar">
  <md-timetracking-calendar-actions
    *mdAutorun
    data-test="nS2EXKyk"
    [viewTabs]="tabs"
    [activeView]="view"
    [hideAddEventButton]="hideAddEventButton"
    (closeHandler)="close()"
    (changeView)="changeView.emit($event)"
    (goNext)="goNext.emit()"
    (goPrevious)="goPrevious.emit()"
    (goTodayOrThisWeek)="goTodayOrThisWeek.emit()"
    (addNewEntry)="addNewEntry.emit()"
  >
    <ng-container title>
      <ng-container *ngIf="view === TimeTrackerViews.MONTH">
        {{ formattedSelectedMonth }}
      </ng-container>
      <ng-container *ngIf="view === TimeTrackerViews.WEEK">
        {{ formattedSelectedWeek }}
      </ng-container>
      <ng-container *ngIf="view === TimeTrackerViews.DAY">
        {{ dayOfWeekOfSelectedDay }}
        <span data-test="XF7GiVv7" class="text-dark-2 font-weight-normal">
          {{ formattedSelectedDateMonth }}
          <span data-test="KEPaXDpk" class="selected-year">
            {{ formattedSelectedYear }}
          </span>
        </span>
      </ng-container>
    </ng-container>
  </md-timetracking-calendar-actions>
  <div *mdAutorun data-test="xbiQn2ZQ" [ngSwitch]="view">
    <mwl-calendar-week-view
      data-test="IK6jJQbv"
      *ngSwitchCase="TimeTrackerViews.WEEK"
      [viewDate]="selectedDate!"
      [events]="calendarEvents"
      [refresh]="refresh"
      [hourSegmentHeight]="70"
      [minimumEventHeight]="40"
      [headerTemplate]="headerTpl"
      [weekStartsOn]="1"
      [eventSnapSize]="30"
      (eventClicked)="onEventClicked($event)"
      (hourSegmentClicked)="onHourSegmentClicked($event)"
      (eventTimesChanged)="onEventTimesChanged($event)"
    ></mwl-calendar-week-view>
    <mwl-calendar-day-view
      data-test="DZpGIuNw"
      *ngSwitchCase="TimeTrackerViews.DAY"
      [viewDate]="selectedDate"
      [events]="selectedDateCalendarEvents"
      [refresh]="refresh"
      [hourSegmentHeight]="70"
      [minimumEventHeight]="40"
      [hourSegments]="1"
      [eventSnapSize]="15"
      (eventClicked)="onEventClicked($event)"
      (hourSegmentClicked)="onHourSegmentClicked($event)"
      (eventTimesChanged)="onEventTimesChanged($event)"
    ></mwl-calendar-day-view>

    <mwl-calendar-month-view
      data-test="oXMlTA2m"
      *ngSwitchCase="TimeTrackerViews.MONTH"
      [viewDate]="selectedDate!"
      [events]="calendarEvents"
      [refresh]="refresh"
      (eventClicked)="onEventClicked($event)"
      (eventTimesChanged)="onEventTimesChanged($event)"
    ></mwl-calendar-month-view>
  </div>

  <ng-template #eventTpl>
    <div data-test="PaD0iWpx" class="task">
      <div data-test="I_XXV5aD" class="task__name"></div>
      <div data-test="mY6I25Vq" class="task__schedule"></div>
    </div>
  </ng-template>

  <ng-template
    #headerTpl
    let-days="days"
    let-locale="locale"
    let-trackByWeekDayHeaderDate="trackByWeekDayHeaderDate"
  >
    <div data-test="M473JWkF" class="cal-day-headers" role="row">
      <div
        data-test="Do5REYFI"
        class="cal-header"
        *ngFor="let day of days; trackBy: trackByWeekDayHeaderDate"
        [class.cal-past]="day.isPast"
        [class.cal-today]="day.isToday"
        [class.cal-future]="day.isFuture"
        [class.cal-weekend]="day.isWeekend"
        [ngClass]="day.cssClass"
        mwlDroppable
        dragOverClass="cal-drag-over"
        tabindex="0"
        role="columnheader"
      >
        <span data-test="mRpMw5P8">
          {{ day.date | date: 'EEE, d' }}
        </span>
      </div>
    </div>
  </ng-template>
</div>
